import { ISiteNetworkOption } from 'types/siteNetwork.interface'

export const vehicleOptions: ISiteNetworkOption[] = [
  { label: 'Haul truck · loaded', value: 'HAUL_TRUCK|LOADED' },
  { label: 'Haul truck · empty', value: 'HAUL_TRUCK|EMPTY' },
  { label: 'Light vehicle', value: 'LV|NA' },
  { label: 'Crew bus', value: 'BUS|NA' },
  { label: 'On foot', value: 'PERSON|NA' },
]

export const roadClassOptions: ISiteNetworkOption[] = [
  { label: 'Haul primary', value: 'HAUL_PRIMARY' },
  { label: 'Haul ramp', value: 'HAUL_RAMP' },
  { label: 'Bench access', value: 'BENCH_ACCESS' },
  { label: 'Service road', value: 'SERVICE_ROAD' },
  { label: 'LV only', value: 'LIGHT_VEHICLE_ONLY' },
  { label: 'Pedestrian', value: 'PEDESTRIAN' },
]

export const roadEventTypeOptions: ISiteNetworkOption[] = [
  { label: 'Closed', value: 'CLOSED' },
  { label: 'Restricted', value: 'RESTRICTED' },
  { label: 'Speed limit', value: 'SPEED_LIMIT' },
  { label: 'Degraded', value: 'DEGRADED' },
]

export const roadClassColors: { [key: string]: string } = {
  HAUL_PRIMARY: '#FFD166',
  HAUL_RAMP: '#F59E0B',
  BENCH_ACCESS: '#E8B04B',
  SERVICE_ROAD: '#9AD1FF',
  LIGHT_VEHICLE_ONLY: '#3B82F6',
  PEDESTRIAN: '#A3A3A3',
}

export const defaultRoadClassColor = '#9AD1FF'
